import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import type { WorkplaceConditionContext } from '../../domain/workplaceCondition/workplaceConditionContext';

type WorkplaceConditionContextRowsProps = {
  context: WorkplaceConditionContext;
  title?: string;
};

export const WorkplaceConditionContextRows: React.FC<WorkplaceConditionContextRowsProps> = ({
  context,
  title = 'Condition context',
}) => (
  <Box data-testid="workplace-condition-context-rows">
    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
      {title}
    </Typography>
    <Stack spacing={0.75}>
      {context.rows.map((row) => (
        <Typography key={row.key} variant="body2" color="text.secondary">
          {row.label}: {row.value}
        </Typography>
      ))}
    </Stack>
  </Box>
);

export default WorkplaceConditionContextRows;
